import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=71b63cba&scoped=true&lang=pug&"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItem.vue?vue&type=style&index=0&id=71b63cba&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b63cba",
  null
  
)

/* custom blocks */
import block0 from "./ShoppingCartItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports